var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.92,330.2H263.17a5.87,5.87,0,0,1-5.86-5.86V61.06a5.87,5.87,0,0,1,5.86-5.86H443.92a5.87,5.87,0,0,1,5.86,5.86V324.34A5.87,5.87,0,0,1,443.92,330.2ZM263.17,55.45a5.62,5.62,0,0,0-5.61,5.61V324.34a5.62,5.62,0,0,0,5.61,5.61H443.92a5.61,5.61,0,0,0,5.61-5.61V61.06a5.61,5.61,0,0,0-5.61-5.61ZM235.49,330.2H54.75a5.87,5.87,0,0,1-5.87-5.86V61.06a5.87,5.87,0,0,1,5.87-5.86H235.49a5.86,5.86,0,0,1,5.86,5.86V324.34A5.86,5.86,0,0,1,235.49,330.2ZM54.75,55.45a5.62,5.62,0,0,0-5.62,5.61V324.34A5.62,5.62,0,0,0,54.75,330H235.49a5.61,5.61,0,0,0,5.61-5.61V61.06a5.61,5.61,0,0,0-5.61-5.61ZM500,391.27H0v.25H500ZM51.67,405.78H67.73v-.25H51.67Zm118.68-2.71h53.53v-.25H170.35Zm-101.62,12H105v-.25H68.73Zm309.62-12.13h43.19v-.25H378.35Zm52.1,0h6.33v-.25h-6.33Zm-114.24,6.23H370.1v-.25H316.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.91,
    y: 104.37,
    width: 48.58,
    height: 62.33,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.04,
    y: 104.37,
    width: 57.07,
    height: 62.33,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.3,
    y: 109.9,
    width: 46.3,
    height: 51.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.51,
    y: 126.28,
    width: 16.71,
    height: 18.5,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.6,405.42a17.17,17.17,0,0,0,0-4.76c-.11-.94-.22-1.85-.31-2.75-2.57.59-4.83.1-5.65-1.44-1.12-2.11.88-5.37,4.48-7.29l.52-.26c-.49-14.6,2.13-21.62,2.13-21.62-6.29.21-14.3,3.26-21.53,7.8a8.45,8.45,0,0,1,.57,2.24c.33,2.89-.78,5.39-2.47,5.59-1.52.17-3-1.58-3.51-4-6.15,4.8-11.08,10.56-12.89,16.22a35.13,35.13,0,0,0-7.61-1.73c.57,1.64.32,3.21-.64,3.66s-2.64-.6-3.49-2.44a5.68,5.68,0,0,1-.46-1.53c-5.94-.09-11.8,1-15.62,3.13,0,0,4.09,3.22,9.06,12.08l.4,0c2.84-.16,5.21,1.06,5.3,2.72.07,1.21-1.1,2.32-2.84,2.89.27.57.53,1.15.8,1.76,4.91,11,15.49,2.12,14.88-5.59,0,0,5-1.32,7.51-4a32.26,32.26,0,0,0,8.92-1.2,13.91,13.91,0,0,0,4.69,5.17,11.63,11.63,0,0,0-2.1,2c-5.43,6.7,6.74,9,6.74,9-.09,6.77,9.66,13.92,13.31,4,.2-.54.41-1.06.61-1.58-1.55-.4-2.64-1.3-2.65-2.36,0-1.46,2-2.65,4.47-2.68h.35c3.84-8,7.22-11.08,7.22-11.08A25.17,25.17,0,0,0,219.6,405.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.86,412.44c-7.49,4.79-22.58,15.7-24.67,17.21.17,2.11.42,4.22.8,6.31l-.74.14c-.38-2.1-.63-4.22-.8-6.34a.37.37,0,0,1-.07-.12c-2.32-6.79-10.14-21.42-23.17-28.19a.36.36,0,0,1-.16-.5.37.37,0,0,1,.5-.16c12.07,6.26,19.73,19.14,22.77,26.59a66.79,66.79,0,0,1,14.07-43.7l.59.47a66,66,0,0,0-13.85,44.62c3.1-2.25,17.17-12.38,24.32-17a.38.38,0,0,1,.41.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.91,441.84l-5.23,24.37H182.93l-5.86-24.37h-3.59l0-7.57h41.23l0,7.57Zm-32.2-9.12a.25.25,0,0,0-.25-.25h-3.67a.25.25,0,1,0,0,.5h3.67A.25.25,0,0,0,179.71,432.72Zm11.74,0a.25.25,0,0,0-.25-.25h-10a.25.25,0,1,0,0,.5h10A.25.25,0,0,0,191.45,432.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.95,
    y: 273.67,
    width: 32.5,
    height: 13.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.01,
    y: 260.28,
    width: 32.5,
    height: 13.5,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.09,
    y: 286.91,
    width: 32.5,
    height: 13.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.7,
    y: 363.99,
    width: 32.5,
    height: 13.5,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.95,
    y: 377.49,
    width: 32.5,
    height: 13.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.06,
    y: 240.17,
    width: 32.5,
    height: 13.5,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.31,
    y: 253.67,
    width: 32.5,
    height: 13.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.7,
    y: 47.88,
    width: 32.5,
    height: 13.5,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.95,
    y: 61.38,
    width: 32.5,
    height: 13.5,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.88,468.41c0,3.38-93.52,6.13-208.88,6.13s-208.88-2.75-208.88-6.13,93.52-6.14,208.88-6.14S458.88,465,458.88,468.41Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Waterfall--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.24,356.86H166.7a9,9,0,0,1-9-9V237.31a9,9,0,0,1,9-9H277.24a9,9,0,0,1,9,9V347.85A9,9,0,0,1,277.24,356.86Zm-97.27,5h50.37a.75.75,0,0,0,0-1.5H180a.75.75,0,0,0,0,1.5Zm53.81,0h3.86a.75.75,0,1,0,0-1.5h-3.86a.75.75,0,0,0-.75.75.76.76,0,0,0,.75.75Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.44,306.93v2h-8.2c-.07-3.56-.1-7.22,0-8.06h15.49v-8.26H230.34v2.21l-.09,0H222c-.08-3.74-.11-7.6,0-8.18a.34.34,0,0,0,0-.1h15.67v-8.25H213.24v2.22a1.07,1.07,0,0,0-.3-.06h-8.31c-.08-3.75-.1-7.61,0-8.19,0,0,0,0,0-.07h15.88v-8.25H196.14v2.34h-8.3c-.08-3.75-.11-7.61,0-8.18a1.07,1.07,0,0,0,0-.25h15.58v-8.26H179.05v8.26h6.8c-.15,1.28-.08,5.75,0,9.45a1,1,0,0,0,1,1h9.28v3.91h6.49c-.13,1.49-.06,5.74,0,9.28a1,1,0,0,0,1,1h9.29a.82.82,0,0,0,.3-.07v4.16H220c-.13,1.45-.07,5.74,0,9.31a1,1,0,0,0,1,1h9.37v4.08h6.89c-.11,1.62,0,5.68,0,9.09a1,1,0,0,0,1,1h9.18v4.28H271.8v-8.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.43,333.61,200,341h-1.83l-1.62-5-1.67,5h-1.82l-2.42-7.36h1.77l1.66,5.17,1.74-5.17h1.57l1.69,5.21,1.71-5.21Zm5.55,5.78h-3.42l-.65,1.58h-1.74l3.28-7.36h1.68l3.29,7.36h-1.79Zm-.54-1.29-1.16-2.82-1.17,2.82Zm4.9-3.11H210v-1.38h6.41V335h-2.35v6h-1.71ZM223,339.6V341h-5.7v-7.36h5.57V335H219v1.6h3.41v1.33H219v1.7Zm6.05,1.37-1.42-2.05h-1.57V341h-1.7v-7.36h3.18a4.19,4.19,0,0,1,1.7.32,2.53,2.53,0,0,1,0,4.67l1.65,2.37Zm-.43-5.64a1.76,1.76,0,0,0-1.17-.34h-1.39v2.57h1.39a1.76,1.76,0,0,0,1.17-.34,1.32,1.32,0,0,0,0-1.89Zm5.17-.36v1.95h3.41v1.37H233.8V341h-1.7v-7.36h5.56V335Zm9.56,4.42h-3.42l-.65,1.58h-1.75l3.28-7.36h1.68l3.29,7.36H244Zm-.54-1.29-1.17-2.82-1.16,2.82Zm3.74-4.49h1.7v6H252V341h-5.4Zm6.35,0h1.71v6h3.68V341h-5.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Kanban--inject-81"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.35,
    y: 227.27,
    width: 128.55,
    height: 128.55,
    rx: 7.06,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.35,
    y: 227.27,
    width: 128.55,
    height: 128.55,
    rx: 7.06,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.85,339.31l-1,1v1.87h-1.69v-7.36h1.69v3.43l3.26-3.43H342L339,338.13l3.23,4.08h-2Zm9.61,1.32h-3.41l-.65,1.58h-1.75l3.28-7.36h1.68l3.29,7.36h-1.78Zm-.53-1.3-1.17-2.81-1.17,2.81Zm10.49-4.48v7.36H356l-3.67-4.47v4.47h-1.68v-7.36h1.41l3.66,4.46v-4.46Zm8.14,4.2a1.82,1.82,0,0,1,.36,1.15,1.69,1.69,0,0,1-.76,1.48,3.81,3.81,0,0,1-2.19.53h-3.8v-7.36h3.59a3.55,3.55,0,0,1,2.07.51,1.63,1.63,0,0,1,.72,1.4,1.82,1.82,0,0,1-.26,1,1.77,1.77,0,0,1-.72.66A1.89,1.89,0,0,1,365.56,339.05Zm-4.7-2.92v1.73h1.69a1.71,1.71,0,0,0,1-.22.73.73,0,0,0,.32-.65.75.75,0,0,0-.32-.65,1.8,1.8,0,0,0-1-.21Zm3,4.57a.75.75,0,0,0,.34-.68c0-.61-.45-.92-1.36-.92h-2v1.82h2A1.89,1.89,0,0,0,363.86,340.7Zm8.19-.07h-3.41l-.65,1.58h-1.75l3.28-7.36h1.68l3.29,7.36h-1.78Zm-.53-1.3-1.17-2.81-1.17,2.81ZM382,334.85v7.36h-1.4l-3.67-4.47v4.47h-1.68v-7.36h1.41l3.66,4.46v-4.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,263.7h-9.81v-9.81H336Zm14.32-9.81h-9.81v9.81h9.81Zm14.33,0h-9.81v9.81h9.81ZM336,267.5h-9.81v9.81H336Zm14.32,0h-9.81v9.81h9.81Zm14.33,0h-9.81v9.81h9.81ZM336,281.1h-9.81v9.82H336Zm14.32,0h-9.81v9.82h9.81ZM336,295.76h-9.81v9.81H336Zm43-41.87H369.2v9.81H379Zm14.33,0h-9.81v9.81h9.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.12,313.36l-3.81-3.22a1,1,0,0,0-1.3,1.53l1.72,1.45h-61.5a1,1,0,0,0,0,2h61.84L386.19,317a1,1,0,0,0,.7,1.71,1,1,0,0,0,.71-.3l3.58-3.59a1,1,0,0,0-.06-1.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Scrum--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.42,217.51H305.85a8.5,8.5,0,0,1-8.5-8.49V97.45a8.5,8.5,0,0,1,8.5-8.49H417.42a8.49,8.49,0,0,1,8.49,8.49V209A8.49,8.49,0,0,1,417.42,217.51Zm13.65-75.37v50.13a.75.75,0,0,0,1.5,0V142.14a.75.75,0,0,0-1.5,0Zm1.25,55.56v5a.75.75,0,0,0,1.5,0v-5a.75.75,0,0,0-1.5,0Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.47,203.6a4.1,4.1,0,0,1-1.31-.62l.58-1.28a3.91,3.91,0,0,0,1.12.56,4.27,4.27,0,0,0,1.31.21,2,2,0,0,0,1.07-.22.65.65,0,0,0,.35-.57.55.55,0,0,0-.21-.44,1.6,1.6,0,0,0-.52-.28c-.22-.07-.51-.14-.87-.23a10.45,10.45,0,0,1-1.38-.4,2.17,2.17,0,0,1-.92-.64,1.74,1.74,0,0,1-.38-1.18,2,2,0,0,1,.35-1.16,2.36,2.36,0,0,1,1-.82,4.18,4.18,0,0,1,1.71-.31,5.79,5.79,0,0,1,1.38.17,3.88,3.88,0,0,1,1.17.48l-.52,1.3a4.06,4.06,0,0,0-2-.58,2,2,0,0,0-1.06.23.73.73,0,0,0-.34.61.59.59,0,0,0,.4.56,5.59,5.59,0,0,0,1.2.37,12.49,12.49,0,0,1,1.38.39,2.43,2.43,0,0,1,.92.64,1.69,1.69,0,0,1,.38,1.16,2,2,0,0,1-.35,1.15,2.37,2.37,0,0,1-1.06.83,4.36,4.36,0,0,1-1.71.3A6,6,0,0,1,337.47,203.6Zm7.46-.25A3.74,3.74,0,0,1,343.5,202a4,4,0,0,1,0-3.92,3.74,3.74,0,0,1,1.43-1.36,4.55,4.55,0,0,1,3.78-.15,3.47,3.47,0,0,1,1.3,1l-1.1,1a2.33,2.33,0,0,0-1.85-.87,2.48,2.48,0,0,0-1.22.3,2.16,2.16,0,0,0-.83.84,2.45,2.45,0,0,0-.3,1.22,2.48,2.48,0,0,0,.3,1.22,2.14,2.14,0,0,0,.83.83,2.48,2.48,0,0,0,1.22.3,2.33,2.33,0,0,0,1.85-.87l1.1,1a3.45,3.45,0,0,1-1.31,1,4.37,4.37,0,0,1-1.73.33A4.32,4.32,0,0,1,344.93,203.35Zm10.91.36-1.42-2.05h-1.56v2.05h-1.71v-7.36h3.19a4.23,4.23,0,0,1,1.7.32,2.55,2.55,0,0,1,1.11.93,2.62,2.62,0,0,1,.38,1.42,2.39,2.39,0,0,1-1.51,2.32l1.65,2.37Zm-.43-5.64a1.81,1.81,0,0,0-1.17-.33h-1.38v2.56h1.38a1.81,1.81,0,0,0,1.17-.33,1.17,1.17,0,0,0,.4-.95A1.16,1.16,0,0,0,355.41,198.07Zm4.28,4.89a3.37,3.37,0,0,1-.87-2.49v-4.12h1.7v4.06c0,1.31.55,2,1.64,2a1.54,1.54,0,0,0,1.22-.48,2.19,2.19,0,0,0,.42-1.49v-4.06h1.68v4.12a3.48,3.48,0,0,1-5.79,2.49Zm14.17.75v-4.42l-2.17,3.64h-.76l-2.16-3.54v4.32h-1.6v-7.36h1.41l2.76,4.57,2.71-4.57h1.4l0,7.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.53,179.2H324.36a1,1,0,0,1,0-2h33.17a24.45,24.45,0,1,0-17.94-7.84l-.47-1.84a1,1,0,0,1,1.94-.5l1.23,4.84a1,1,0,0,1-.13.79,1,1,0,0,1-.67.44l-5,.85h-.17a1,1,0,0,1-.16-2l2.73-.47a26.43,26.43,0,0,1,34.76-39.69A12.19,12.19,0,0,1,394,119.55l0-2.73a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1l.05,5.77a1,1,0,0,1-.29.71,1,1,0,0,1-.6.28h0l-.09,0h-6.13a1,1,0,0,1,0-2h4.22a10.18,10.18,0,1,0,2.31,6.44,1,1,0,1,1,2,0,12.2,12.2,0,0,1-17.28,11.09A26.21,26.21,0,0,1,384,152.76,26.48,26.48,0,0,1,357.53,179.2Zm37.37-1.77a1,1,0,0,0-.07-.29s-.06-.07-.08-.11a.91.91,0,0,0-.18-.21.1.1,0,0,0,0,0l-6.78-5.14a1,1,0,0,0-1.21,1.6l4.41,3.34H372.61a1,1,0,0,0,0,2h18.62l-4.74,4.06a1,1,0,0,0,.65,1.76,1,1,0,0,0,.65-.24l6.79-5.82,0,0a1.14,1.14,0,0,0,.21-.28s0,0,0-.06a1,1,0,0,0,.08-.39v0h0A.45.45,0,0,0,394.9,177.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Agile--inject-81"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.01,
    y: 88.96,
    width: 128.55,
    height: 128.55,
    rx: 7.49,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.01,
    y: 88.96,
    width: 128.55,
    height: 128.55,
    rx: 7.49,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.82,150.19a32.22,32.22,0,0,1,28.05-31.9,1,1,0,0,1,.25,2A30.16,30.16,0,0,0,211,175.75a1,1,0,0,1-.53,1.85.94.94,0,0,1-.53-.16A32,32,0,0,1,194.82,150.19ZM227,182.35H190.31v3.18a1,1,0,0,1-1,1h-8.93a1,1,0,0,1-1-1V176.6a1,1,0,0,1,1-1h8.93a1,1,0,0,1,1,1v3.75H227a30.15,30.15,0,0,0,2.63-60.19l1.7,1.67a1,1,0,0,1-1.41,1.43l-3.4-3.37a1,1,0,0,1,.11-1.78l3.37-2.7a1,1,0,1,1,1.25,1.56l-1.48,1.19A32.15,32.15,0,0,1,227,182.35Zm-38.67,2.18v-2.74a1.09,1.09,0,0,1-.1-.44,1,1,0,0,1,.1-.43V177.6h-6.93v6.93Zm82.44-4-3.2-3.17a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l1.48,1.46H244.78a1,1,0,0,0,0,2h23.11L266.34,184a1,1,0,0,0,.11,1.4,1,1,0,0,0,.65.24,1,1,0,0,0,.76-.35l2.95-3.48A1,1,0,0,0,270.75,180.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.53,200.26h-3.42l-.65,1.58h-1.75l3.28-7.36h1.69l3.29,7.36h-1.79ZM214,199l-1.17-2.82L211.66,199Zm8.61-.93h1.56v3a4.52,4.52,0,0,1-1.39.69,5.48,5.48,0,0,1-1.59.24,4.27,4.27,0,0,1-2.06-.49,3.51,3.51,0,0,1-1.43-1.35,4,4,0,0,1,0-3.92,3.63,3.63,0,0,1,1.44-1.36,4.34,4.34,0,0,1,2.08-.49,4.52,4.52,0,0,1,1.76.33,3.4,3.4,0,0,1,1.32.94l-1.09,1a2.65,2.65,0,0,0-3.15-.53,2.08,2.08,0,0,0-.86.83,2.44,2.44,0,0,0-.3,1.23,2.48,2.48,0,0,0,.3,1.22,2.26,2.26,0,0,0,.85.83,2.5,2.5,0,0,0,1.24.3,2.74,2.74,0,0,0,1.32-.31Zm3.13-3.56h1.71v7.36h-1.71Zm3.45,0h1.71v6h3.69v1.39h-5.4Zm12,6v1.37h-5.7v-7.36h5.56v1.36h-3.87v1.6h3.42v1.33h-3.42v1.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.32,300.84C416,321.11,410.93,351.12,420.65,376c10.81-9.64,18.41-24.34,18.89-37.19S436.66,313.26,433.32,300.84Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.3,378.3A49.78,49.78,0,0,0,422.42,409c9.37-3.26,17.63-13.85,22.58-22.44s7.73-18.26,10.24-27.85A49.74,49.74,0,0,0,430.3,378.3Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.64,392.35A41.51,41.51,0,0,1,415.21,418c-7.81-2.72-14.7-11.55-18.83-18.72S389.94,384,387.84,376A41.49,41.49,0,0,1,408.64,392.35Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.11,394.71c-11,11.34-22.27,22.44-33.29,33.78q.18,3.43.44,6.85c0,.48-.71.48-.75,0q-.43-5.59-.66-11.19s0,0,0-.07a192.82,192.82,0,0,0-22.33-38.73c-.29-.39.36-.76.65-.38a195.71,195.71,0,0,1,21.67,37.24c-.1-3-.17-6-.17-9a287,287,0,0,1,10.49-77,.37.37,0,0,1,.72.2q-2.93,10.55-5.06,21.3a285.32,285.32,0,0,0-5.37,58.67,238.59,238.59,0,0,1,27-46.91c.28-.39.93,0,.65.38a236.74,236.74,0,0,0-27.27,47.62.38.38,0,0,1-.31.24q.07,4.86.33,9.74c10.87-11.17,22-22.13,32.81-33.3C451.92,393.83,452.45,394.36,452.11,394.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.51,389.48a218.3,218.3,0,0,0-26,30.15h1.75a25.82,25.82,0,0,0,24.25-30.15Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.22,367.49q6.15,10.08,11.6,20.57c.22.43.87.05.65-.38Q414,377.2,407.86,367.11c-.25-.41-.9,0-.64.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.33,333.57c-1.57,7-3.12,16.21-3.14,23.54s2.22,14.5,6.39,19.42,12.59,7.06,16,4.25Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.9 431.77 397.11 431.77 397.11 439.52 401.75 439.52 406.18 467.11 432.13 467.11 435.63 439.52 438.9 439.52 438.9 431.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.78 439.66 435.61 439.66 435.19 442.99 402.31 442.99 401.78 439.66",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.62,87.07a.25.25,0,0,1-.12.33.23.23,0,0,1-.11,0,.25.25,0,0,1-.22-.15,9.19,9.19,0,0,1-.83-3.68.24.24,0,0,1,.24-.26.26.26,0,0,1,.26.25A8.7,8.7,0,0,0,91.62,87.07Zm8-28.27a.26.26,0,0,0,0-.35.25.25,0,0,0-.35-.05,25,25,0,0,0-9.4,21.53.25.25,0,0,0,.24.23h0a.24.24,0,0,0,.22-.27A24.49,24.49,0,0,1,99.59,58.8Zm39.88,34.14a24.86,24.86,0,0,1-26.14,10.54l-6.07,4.36-1.9-7.66c-.11-.07-.24-.13-.35-.21a24.87,24.87,0,1,1,34.46-7Zm-8-18L128,71.44,116.33,82.87l-7-6.43L106,80.1l10.49,9.58Z",
    style: {
      fill: "#FFC100"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.65,161.58a7.28,7.28,0,0,0,.44-.69c1.68-2.87,1.71-6.68.7-10l0-.11c1.24-3.61,3.06-5.49,1.52-11.18a39,39,0,0,0-9.18-16.16c-2.41-2.6-5.14-5-8.43-6s-7-.67-9.5,1.73c0,0-2,1.85-4.15,6.58-3.93,8.77-.62,20.11,2.25,26.45a12.37,12.37,0,0,0-2.78.34,11.8,11.8,0,0,0-2.87,1.12,10.14,10.14,0,0,0-1,.58A11.47,11.47,0,0,0,75,155.56a11.6,11.6,0,0,0-1.8,2.27c-2.4,3.88-3.49,8.87-1.31,12.87,6-4.2,4.58,1.3,9.61,1.3,8.73,0,17.1,1,17.1,1a2.67,2.67,0,0,0,0-.57,14,14,0,0,0,5.85,0,13.69,13.69,0,0,0,3.63-1.3C109.56,170.34,114.52,165.37,109.65,161.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.64,123.68c-10.18-5-20.74,2.63-20.51,13.44.23,10.46.13,15.07,4.79,20.68a5.54,5.54,0,0,0,0,.56,4.36,4.36,0,0,0,0,.51c1,5.72.85,9.47-1.82,12.61,0,0-4.17,6.81,9.93,11.88,2.37,1,4,1.58,5.76-.25,6-6.17,5.91-8.9,4.81-9.53-1.8-.91-6.23-4.76-6.38-7.38a49.1,49.1,0,0,1,0-1.4v-1.07A12.65,12.65,0,0,0,104,154.2C106.6,144.66,105.82,128.64,95.64,123.68Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.64,125.13c-.87-3.08-4.22-5.72-10.34-7.06L86,118c-5.84-1.22-12.1-3.1-14.59,3.34-6.52,16.8-16.12,14.49-14,19.64a3.82,3.82,0,0,0,3.53,2.13,3.06,3.06,0,0,0,1.08-.22c-.43.39-.93.79-1.39,1.22-2.5,2.37-4.93,5.17-5.92,8.56a4.9,4.9,0,0,0-.34,1.74,4.85,4.85,0,0,0,4.81,4.89c-.22.24-2.78,2.89-3.18,3.57-4.48,7.47-1.13,17.32,9.28,13,2.83-1.17,10.59-4.13,10.59-4.13s3,2.87,3-2.66l.21.1a.31.31,0,0,1,0-.1,26.34,26.34,0,0,1-2.1-13.57c0-.26.06-.53.1-.79.12-.82.33-1.73.47-2.42a14.46,14.46,0,0,1,.51-1.89,26.43,26.43,0,0,1,1.36-3.46c.32-.65.65-1.29,1-1.9l.28-.43a17.43,17.43,0,0,1,6.58-6.54C94.53,134.36,98,129.3,96.64,125.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.35,146.36a8.72,8.72,0,0,0,4.92,4.55c2.81,1,4.68-3.53,3.94-6.48A5.77,5.77,0,0,0,73,140.14C70.24,140.47,69.1,143.7,70.35,146.36Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.07,122.12c-1.14,3.54-4.31,3.38-6.3,6.52s-3.14,7.46-.93,10.45a26.74,26.74,0,0,1,2,2.47c1.46,2.59-.2,5.78-.26,8.75,0,2.76-.2,6,2,7.48a6.84,6.84,0,0,1,3,5.53c0,.7-2.15,5.44-2.26,6.12-.15,1,2.66-2.12,3.66-2a1.84,1.84,0,0,0,1.84-.87c.06-.11.11-.22.16-.33a12.69,12.69,0,0,0,.38-10.77c-.86-2-1.8-3.87-2.65-5.83a10.77,10.77,0,0,1-1.06-6.24c.93-4.8,12.36-15.64,3.25-24.44a.64.64,0,0,0-.45-.19A2.28,2.28,0,0,0,80.67,120,9.93,9.93,0,0,0,80.07,122.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,141.86a36.76,36.76,0,0,0,3,6.89.84.84,0,0,1-.5,1.25,5.38,5.38,0,0,1-2.91-.2Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,152.76a25.54,25.54,0,0,0-2.1,3l-.61-.23c-2.73-1.1-3.63-2.51-3.81-3.75a3.87,3.87,0,0,1,.22-1.78,3.6,3.6,0,0,1,.46-.92c1.1,1.45,3.57,2.67,4.91,3.26C95.59,152.63,96,152.76,96,152.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,152.37l-.64.88c-2.57-1-4.24-2.12-4.73-3.22a3.6,3.6,0,0,1,.46-.92C91.22,150.56,93.69,151.78,95,152.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.25,155.56c-2.73-1.1-3.63-2.51-3.81-3.75a9.6,9.6,0,0,1,2.8,1.82A3.53,3.53,0,0,1,93.25,155.56Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.67,137.49a.48.48,0,0,1-.4.09.56.56,0,0,1-.34-.21.55.55,0,0,1,.08-.76,4.89,4.89,0,0,1,4.63-.82.59.59,0,0,1,.34.7.5.5,0,0,1-.66.31A3.91,3.91,0,0,0,87.67,137.49Zm16.32-.92a4.49,4.49,0,0,0-4.36-.66.5.5,0,0,0-.18.68.51.51,0,0,0,.65.28,3.57,3.57,0,0,1,3.46.56.48.48,0,0,0,.38.07.37.37,0,0,0,.26-.21A.58.58,0,0,0,104,136.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.19,139.88a2,2,0,0,0-1,1.89c0,1.15.5,2.14,1.21,2.22s1.33-.8,1.37-2a2.86,2.86,0,0,0-.45-1.72,3,3,0,0,0,1.37-.87l-2.54.38Zm10.8.89c-.6.12-1.07.89-1.11,1.87s.5,2.08,1.21,2.15,1.32-.77,1.36-1.88a2.69,2.69,0,0,0-.44-1.64,2.78,2.78,0,0,0,1.51-.89l-2.54.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69,446.42,60.81,448,63,447l1.38,6.84,9.36,13.08s3.56.57.75-6.86a6.77,6.77,0,0,1-.29-1.12c-.83-4.45,1-13,1-13l-5.14-7.17a11.14,11.14,0,0,0-1.44.16C66.52,439.33,62.26,440.37,59.69,446.42Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69,446.42,60.81,448,63,447l1.38,6.84,9.36,13.08s3.56.57.75-6.86a6.77,6.77,0,0,1-.29-1.12c-.83-4.45,1-13,1-13l-5.14-7.17a11.14,11.14,0,0,0-1.44.16C66.52,439.33,62.26,440.37,59.69,446.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.65,439h0c1.73.19.22,7.85.91,12.14.63,3.83,2.28,7.45,4.7,7.83-.83-4.45,2.17-14.57,2.17-14.57l-4.13-5.77S69.56,438.83,68.65,439Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,466.45h1.9l.53-2.37L82.76,467h16s2.54-2.58-5.08-4.63a6.05,6.05,0,0,1-1.07-.42c-4.07-1.92-9.85-8.4-9.85-8.4H74a10.46,10.46,0,0,0-.72,1.27C72.31,456.72,70.66,460.8,74,466.45Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,454.77v0c1.16-1.3,6.43,4.42,10.29,6.36,3.45,1.73,7.33,2.5,9,.74C88.54,460,82.1,451.16,82.1,451.16l-7.06.22S73.68,453.94,73.27,454.77Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.91,337.21v-.12l-6.58-39.89C122,279.26,114.16,248,114.16,248l-3.36-12.56-31.51,0a1.66,1.66,0,0,0,0,.21l-10.77-.21S54,245.33,55.91,281.2c.8,14.91,5.92,52.34,5.44,58.08-5.62,44,5.49,112.63,5.49,112.63l16.53-.81c-.08-1.35-.13-2.94-.15-4.73a2.57,2.57,0,0,0,.55,0c2.36-6.5,6.14-15.85,10.78-26.56,4.41-10.15,9.57-21.5,15-32.82,4.16-8.58,11.74-18,16-26A45.07,45.07,0,0,0,130.91,337.21ZM88.55,377.49c-.9,2.48-1.75,5-2.57,7.46,1.67-25.1,3.47-47.19,3.47-47.19.42-5.6,1.8-17,3.51-30.2,3.13,10.88,7,23.05,11.68,36.58C98.24,353.69,92.91,365.49,88.55,377.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,385c.82-2.48,1.67-5,2.57-7.46,2.22,12.43,4.71,28.14,6,42.33-4.64,10.71-8.42,20.06-10.78,26.56a2.57,2.57,0,0,1-.55,0C83.07,432.85,84.47,407.67,86,385Zm10.91-106.6c-1.4,10.17-2.85,20.87-4.1,30.51,1.48,3.78,3.06,7.94,4.56,12.95,5.49-26.91,1-45,1-45C97.9,277.24,97.41,277.77,96.89,278.35Zm-41.16-6.8v4.24l23.56,2.8,2.62-41.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.46,193.13c-.52-7.91-10.09-19.1-10.09-19.1-.53-.06-4.06-.11-4.6-.17l-1.68-.13-4.54-6.24-2.36,4-7.12-5.26-3.84,1.81,1.88,5.52c-2.43.15-5,.35-7.65.57-1,.09-2,.18-2.94.3s-9.58.32-9.58.32-3.52,7.38-1.45,13.92c6.39,20.12,10.1,39.27,11,49.72l39.39-.71c.48-10.09,5.68-20.54,5.73-27.71C115.87,199.45,113.74,197.55,113.46,193.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.22,219.21c.24-4.6.39-8.89.39-12.58,1.33-27.31-4.23-38.3-4.23-38.3l-.15-.25c-1.1.88-2.93,2.16-4.53,3.23l-11.13,1.37v0c-6.33,1.08-19.91,29.44-25.29,43.43-1.63,4.25,2,9.69,5.12,10.56,3.33.92,13,1.84,22.23,2.56l-15.39,43.1L78,275.25S80.83,252,82.48,230.4l3.43.2,1.34-10.55Zm-26.11-5.47L62,206.32c.59,2.3,1.2,4.63,1.8,6.89.2.75.39,1.42.57,2Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,198.58a7.55,7.55,0,0,1-1-5c.59-2.44.41-4.54,1-6.33s1.56.54,1.84,1.88.62,2.85,1.59,2.48,6.62-7.33,8-7.69.84,1,.84,1,1.42-1.65,2.22-1.27c.21.1.54.67,0,1.53C153.68,187.14,151,191,151,191c.15-.23,3.83-4.81,4.47-5.42.84-.8,1.64-.76,2.09-.26.64.72-3.72,6.55-3.74,6.92,0,0,2.4-3.44,3.63-3.3s-.16,2.38-1.77,4.13c-1.47,1.6-3.93,5.14-5.59,6.62-2,1.83-3.82,2.6-6.17,1.57A8.74,8.74,0,0,1,140.4,198.58Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29,189.59a.25.25,0,0,1-.14,0,.25.25,0,0,1-.06-.35c1-1.45,2-2.87,3.13-4.22a.24.24,0,0,1,.35,0,.25.25,0,0,1,0,.35c-1.09,1.33-2.14,2.74-3.11,4.18A.26.26,0,0,1,149.29,189.59Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.92,193.9a.25.25,0,0,1-.21-.1,11.33,11.33,0,0,0-5.16-4,.25.25,0,1,1,.18-.47,11.9,11.9,0,0,1,5.39,4.16.25.25,0,0,1-.06.35A.23.23,0,0,1,152.92,193.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.29,198a.3.3,0,0,1-.16-.05.25.25,0,0,1,0-.35,3.73,3.73,0,0,0-.22-4.76.25.25,0,1,1,.37-.33,4.25,4.25,0,0,1,.25,5.39A.25.25,0,0,1,144.29,198Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.34,232.39c1.91,2.34,4.22,3.8,6.92,3.08,2.91-.78,26.78-32.3,26.78-32.3L137.82,195l-16.19,15s-1.88-15.07-5.16-24.88a21.56,21.56,0,0,0-10.94-12.53l-.58-.29-4.59-.31-.42-.28c-2.2-1.49-6.52-3.75-7.09-3.57L94,169.5l-.15-.06s.75.9,1.93,2.42c5.17,7,15.52,21.85,15.59,29,.09,9.18.18,11.21.18,11.21h0c-.71,9.22-2.32,19.64-2,23.44.86,10,5.29,22.31,11,40.3l3.8-.54-10.46-39.81S114.05,234.29,114.34,232.39Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.32,200.84c-.1-9.51-18.47-32.76-18.47-32.76.57-.18,4.89,2.08,7.09,3.57,3.22,2.18,6.69,4.31,6.69,4.31l-.94,6.48,7.19,5.32s.1,4.73.53,11.07a39.76,39.76,0,0,1-1.91,13.22S111.41,210,111.32,200.84ZM116.81,235V209l-2.47,23.43A18,18,0,0,0,116.81,235Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.75,199.19h0c.45,3.46.54,7.81-.89,11.48a5.12,5.12,0,0,1-2,2.54c-.6-2.26-1.21-4.59-1.8-6.89Zm12.48-31.11c-2.25,1.82-7.61,5.26-7.61,5.26l5,10-3.77,6.12,10.42,22.4c2.37-31.16-3.9-43.54-3.9-43.54ZM57.11,213.74s-4.47-.7-7.3,1.67c0,0,3-4.89,8.54-3.54ZM82.48,230.4l-16.87-1.15-1,2.79,17.56,2.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.72 174.59 95.69 179.6 90.67 174.59 87.25 180.47 82.14 177.97 87.58 182.28 90.73 175.84 96.5 181.27 97.72 174.59",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.29,221.38l-3.2-2.52a2.88,2.88,0,0,0-2.58-.5l-9.39,2.71-1.21,9.53-.53,0c1.66,4.39,10.33.6,10.33.6l2.15,1.37c1.74,1.1,5.88-.12,6.23-2.16l.25-5.23C104.52,224.09,103.13,222.05,102.29,221.38Z",
    style: {
      fill: "#b97964"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.223a3238effdede31b1012c5f55a295a.svg";
export { ForwardRef as ReactComponent };